import * as React from 'react'
import classNames from 'classnames'

import { Text, TextName } from '../../../../sdk/text/Text'
import lightningImage from '../../assets/lightning.png'
import classes from './style.module.scss'

interface ComponentProps {
  className?: string
}

export const ProcessingFeatureCard: React.FC<ComponentProps> = (props) => {
  const { className } = props

  return (
    <div className={classNames(classes.container, className)}>
      <Text type={TextName.H1} className={`${classes.gradientText} ${classes.h1Text}`}>
        Up to 75X <br /> Faster
      </Text>
      <Text type={TextName.Text} className={classes.bodyText}>
        Compared to <br /> conventional <br /> processors
      </Text>
      <img src={lightningImage} alt='' className={classes.lightningImage} />
    </div>
  )
}
